import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import GallectionCover from '../GallectionCover';
import { ListItemCheckbox } from '@wix/da-ds/pkg/List/ListItem';
const GallectionListItemCheckbox = (_param)=>{
    var { gallection, onChange } = _param, rest = _object_without_properties(_param, [
        "gallection",
        "onChange"
    ]);
    return /*#__PURE__*/ React.createElement(ListItemCheckbox, _object_spread({
        label: gallection.name,
        name: gallection.name,
        prefix: /*#__PURE__*/ React.createElement(GallectionCover, {
            gallection: gallection
        }),
        fillContainerWidth: true,
        controlAlignment: "center",
        onChange: (isSelectedNew)=>{
            onChange && onChange({
                folderId: gallection.folderId,
                isSelected: isSelectedNew
            });
        }
    }, rest));
};
GallectionListItemCheckbox.displayName = 'GallectionListItemCheckbox';
export default GallectionListItemCheckbox;
